import { render, staticRenderFns } from "./SoldRegister.vue?vue&type=template&id=7f8e540c&scoped=true"
import script from "./SoldRegister.vue?vue&type=script&lang=js"
export * from "./SoldRegister.vue?vue&type=script&lang=js"
import style0 from "./SoldRegister.vue?vue&type=style&index=0&id=7f8e540c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8e540c",
  null
  
)

export default component.exports